var EHDI = EHDI || Object.create(null);
var WTE = WTE || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

WTE.Fruit  = function() 
{
    var GROWTH_TIME = 250;
    var FALL_TIME =500;
    var SCORE_WORTH = 5;
    var TIME_WORTH = 2;
    EHDI.aka.Container.call(this);

    this.init = function (willGlow)
    {

        this.setVisual(willGlow);
        this.timer = 0;
        this.isRipe = false;
        this.isPicked = false;
        this.isRotten = false;
        this.fallen = false;
        this.yVel = 0;
    }


    this.setVisual = function(willGlow)
    {
        if(!this.sprite)
            this.sprite  = new EHDI.aka.Sprite(EHDI.Assets.images['pomegranate']);
        else
            this.sprite.texture = EHDI.Assets.images['pomegranate'];

        if(willGlow)
            {
                var assetSize = this.sprite.height;                
                this.glow = new EHDI.components.GlowEffect(75);
                this.glow.y = assetSize * 0.5;
                this.addChild(this.glow);
                this.glow.appear();
            }

        this.sprite.scale.x = this.sprite.scale.y =0;
        this.sprite.alpha = 1;
        this.sprite.y =0;
        this.sprite.anchor.set(0.5, 0);       
        this.addChild(this.sprite);
    }

    this.spawn = function()
    {
        this.isRipe = true;
        this.addInteraction();
    }

    this.rot = function()
    {
        if(this.isRotten)
            return false;

        this.isRotten = true;
        this.timer = 0;
        this.sprite.texture = EHDI.Assets.images['pomegranate_expired'];

        this.removeGlow();
        return true;
    }

    this.removeGlow = function()
    {
        if(this.glow)
            {
                this.glow.disappear();
                this.removeChild(this.glow);
            }
    }
    
    this.update = function(delta)
    {
        this.timer += delta;

        if(this.timer >= EHDI.GAME.constants['fruitDecayTime'])
            this.rot();

        if(this.glow)
            this.glow.update(delta);

        if(!this.isRipe)
        {
            var scale = this.timer/GROWTH_TIME;
            if(scale >= 1)
                {
                    scale = 1;     
                    this.spawn();               
                }
            this.sprite.scale.x = this.sprite.scale.y =scale;
        }
        else if((this.isRotten) && (!this.fallen))
            {
                this.yVel += delta * EHDI.GAME.constants.gravity;
                this.sprite.y += delta * this.yVel;
                this.sprite.alpha = (FALL_TIME- this.timer) / FALL_TIME;

                if(this.timer >= FALL_TIME)
                    this.fallen = true;
            }

    }

    this.addInteraction = function()
    {
        if(EHDI.BrowserInfo.isMobileDevice)
            this.on('touchstart', this.touched);            
        else
            this.on('mousedown', this.touched);

        this.interactive = true;
    }

    this.removeInteraction = function()
    {
        if(EHDI.BrowserInfo.isMobileDevice)
            this.off('touchstart', this.touched);            
        else
            this.off('mousedown', this.touched);

        this.interactive = false;
    }

    this.touched = function()
    {
        if((!this.isRipe) || (this.isPicked) || (this.isRotten))
            return;

        this.isPicked = true;
        EHDI.scene.GameScene.scoreHolder.addScore(SCORE_WORTH);
        EHDI.scene.GameScene.game.adjustTime(TIME_WORTH);                                                  
        EHDI.GAME.soundManager.playSFX("pick_fruit");
        
        this.removeGlow();
        
        // var basketLoc =this.toGlobal(new PIXI.Point(EHDI.scene.GameScene.game.x, EHDI.scene.GameScene.game.y));
        // // var globalLoc =this.toGlobal(new PIXI.Point(basketLoc.x, basketLoc.y));
        EHDI.scene.GameScene.game.fruitScoreEffects.popScore(this.x, this.y, 5);
    }

    this.dispose = function()
    {
        this.removeInteraction();

        if(this.sprite != null)
        {
            this.removeChild(this.sprite);
            this.sprite.destroy({children: true});
        }
        delete this.sprite;

        this.timer = null;
        this.isRipe = null;
        this.isPicked = null;
        this.isRotten = null;
        this.fallen = null;
        this.yVel = null;
    }

    
}
WTE.Fruit.prototype = Object.create(EHDI.aka.Container.prototype);


WTE.FruitMap = Object.create(null);
    
WTE.FruitMap['forbidden'] = 0;
WTE.FruitMap['pomegranate'] =1;